// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tip-component {
  color: var(--ion-color-primary);
  padding: 0px;
  background: #fff;
  border-radius: 0px;
}

.title-row {
  margin-bottom: 13px;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--ion-color-primary);
  margin-right: 10px;
  text-transform: uppercase;
}

.chip {
  width: -moz-fit-content;
  width: fit-content;
  padding: 4px 12px;
  background-color: var(--ion-color-primary);
  border-radius: 100px;
  color: #fff;
  font-family: AppFontBold, sans-serif;
  text-align: start;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: left;
  text-transform: uppercase;
  border-radius: 16px;
}

.tip-img {
  height: 20px;
}

.tip {
  padding: 10px;
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.0588235294);
  border-radius: 16px;
}
.tip .sum {
  color: var(--ion-color-secondary);
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
  text-transform: uppercase;
}
.tip:last-of-type {
  margin-right: 0;
}
.tip.selected {
  background: var(--ion-color-primary);
}
.tip.selected .sum {
  color: white;
}

.custom-tip-row {
  justify-content: space-between;
}
.custom-tip-row ion-icon {
  cursor: pointer;
}

.custom {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.titles-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
}
.titles-wrapper p {
  margin-left: 15px;
}

.delete-tip-col {
  display: flex;
  justify-content: center;
  align-items: center;
}
.delete-tip-col .delete-tip {
  cursor: pointer;
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  text-transform: capitalize;
  color: var(--ion-color-primary);
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tip/tip.component.scss"],"names":[],"mappings":"AAAA;EACC,+BAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AACD;;AAEA;EACC,mBAAA;AACD;;AAEA;EACC,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,yBAAA;AACD;;AAEA;EACC,uBAAA;EAAA,kBAAA;EACA,iBAAA;EACA,0CAAA;EACA,oBAAA;EACA,WAAA;EACA,oCAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AACD;;AAEA;EACC,YAAA;AACD;;AAEA;EACC,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wDAAA;EACA,mBAAA;AACD;AAAC;EACC,iCAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAEF;AACC;EACC,eAAA;AACF;AAEC;EACC,oCAAA;AAAF;AACE;EACC,YAAA;AACH;;AAIA;EACC,8BAAA;AADD;AAGC;EACC,eAAA;AADF;;AAIA;EACC,aAAA;EACA,yBAAA;EACA,eAAA;AADD;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AADD;AAEC;EACC,iBAAA;AAAF;;AAIA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AADD;AAGC;EACC,eAAA;EACA,eAAA;EACA,oCAAA;EACA,0BAAA;EACA,+BAAA;EACA,0BAAA;AADF","sourcesContent":[".tip-component {\n\tcolor: var(--ion-color-primary);\n\tpadding: 0px;\n\tbackground: #fff;\n\tborder-radius: 0px;\n}\n\n.title-row {\n\tmargin-bottom: 13px;\n}\n\n.title {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 18px;\n\tline-height: 22px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tcolor: var(--ion-color-primary);\n\tmargin-right: 10px;\n\ttext-transform: uppercase;\n}\n\n.chip {\n\twidth: fit-content;\n\tpadding: 4px 12px;\n\tbackground-color: var(--ion-color-primary);\n\tborder-radius: 100px;\n\tcolor: #fff;\n\tfont-family: AppFontBold, sans-serif;\n\ttext-align: start;\n\tfont-size: 10px;\n\tline-height: 12px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\ttext-transform: uppercase;\n\tborder-radius: 16px;\n}\n\n.tip-img {\n\theight: 20px;\n}\n\n.tip {\n\tpadding: 10px;\n\tmargin-right: 5px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground: #ffffff;\n\tbox-shadow: 0px 0px 35px 0px #0000000f;\n\tborder-radius: 16px;\n\t.sum {\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 13px;\n\t\tline-height: 19px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t}\n\n\t&:last-of-type {\n\t\tmargin-right: 0;\n\t}\n\n\t&.selected {\n\t\tbackground: var(--ion-color-primary);\n\t\t.sum {\n\t\t\tcolor: white;\n\t\t}\n\t}\n}\n\n.custom-tip-row {\n\tjustify-content: space-between;\n\n\tion-icon {\n\t\tcursor: pointer;\n\t}\n}\n.custom {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tcursor: pointer;\n}\n\n.titles-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding-top: 10px;\n\tp {\n\t\tmargin-left: 15px;\n\t}\n}\n\n.delete-tip-col {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t.delete-tip {\n\t\tcursor: pointer;\n\t\tmargin-top: 5px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\ttext-transform: capitalize;\n\t\tcolor: var(--ion-color-primary);\n\t\ttext-decoration: underline;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
